module.exports = __webpack_public_path__ + "img/best_price-icon-black.56174d3f.svg";